import { CULTURE_LIST } from '../index.js';
import CultureCard from './CultureCard';
export default {
  components: {
    CultureCard
  },
  data() {
    return {
      cultureList: CULTURE_LIST
    };
  }
};